import React, { useEffect } from 'react'

import Platformtoolheader from '../components/PlatformTools/Platformtoolheader';
import WebsiteTools from '../components/PlatformTools/WebsiteTools';
import CarouselSection from '../components/Funding/CarouselSection';

import AOS from "aos";

const PlatFormTools = () => {
  useEffect(() => {
    AOS.init({
      once: false,
    });
    window.addEventListener("load", AOS.refresh);
  }, []);

  return (
    <div>
        <Platformtoolheader/>
        <WebsiteTools/>
        <CarouselSection/>
    </div>
  )
}

export default PlatFormTools;